import React, {useState} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Card} from 'antd';
import {Moment} from 'moment';
import CongressTableEditForm from '../../components/congress/EditForm';
export default function AboutCongressPage() {
  return (
    <AppSideLayout title={'第十次会员代表大会'}>
      <Card style={{flex: 1}} title={'上海市计算机学会第十次会员代表大会登记表'}>
        <CongressTableEditForm />
      </Card>
    </AppSideLayout>
  );
}
